import { Round as DownloadIcon } from '@manomano-internal/tamagoshi-icons/esm/material/GetApp';
import classnames from 'classnames';
import type { FunctionComponent } from 'react';

import { Text } from '@/core/tamagoshi/Text/Text';

import styles from './infoDoc.module.scss';

interface Props {
  url: string;
  name: string;
  handleClick?: (value: string) => void;
  downloadOnClick?: boolean;
  className?: string;
}

export const InfoDoc: FunctionComponent<Props> = ({
  url,
  name,
  handleClick,
  downloadOnClick = false,
  className,
}) => (
  <a
    href={url}
    target={downloadOnClick ? '_self' : '_blank'}
    download={downloadOnClick}
    rel="noopener noreferrer"
    className={classnames(styles.container, className)}
    onClick={() => handleClick && handleClick(url)}
  >
    <DownloadIcon
      width="16px"
      height="16px"
      color="#505971"
      className={styles.icon}
    />
    <Text>{name}</Text>
  </a>
);

InfoDoc.displayName = 'InfoDoc';
